//solo en caso de que no haya configuración recibida
export const DEFAULT_LANGUAGE =  'es';
